export default {"src":"/_next/static/media/search-left-side-dotted-grid.973307b2.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};